import React from 'react';
import { StyledProgress } from './StyledComponents';

type FileProgressProps = {
  percent: number;
};

const FileProgress: React.FC<FileProgressProps> = ({ percent }) => {
  const [hidden, setHidden] = React.useState(false);
  const isMounted = React.useRef(true);

  React.useEffect(() => {
    if (percent === 100) {
      setTimeout(() => {
        if (isMounted.current) setHidden(true);
      }, 1000);
    }
  }, [percent]);

  React.useEffect(() => () => {
      isMounted.current = false;
    }, []);

  return <StyledProgress $hidden={hidden} $width={percent || 0} />;
};

export default FileProgress;
